(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["thelone-language-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('thelone-language-selector')) {
    customElements.define('thelone-language-selector', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const close = () => this.querySelector('details')?.removeAttribute('open');
        const normalizeRoot = root => root === '/' ? '' : root.replace(/\/$/, '');
        document.addEventListener('click', event => { if (!this.contains(event.target)) close(); }, { signal });
        this.addEventListener('click', event => {
          const option = event.target instanceof Element ? event.target.closest('[data-language-root]') : null;
          if (!option) return;
          event.preventDefault();
          if (option.getAttribute('aria-current') === 'page') return;
          const currentRoot = normalizeRoot(this.dataset.currentRoot || '/');
          const targetRoot = normalizeRoot(option.dataset.languageRoot || '/');
          let path = window.location.pathname;
          if (currentRoot && (path === currentRoot || path.startsWith(`${currentRoot}/`))) {
            path = path.slice(currentRoot.length) || '/';
          }
          window.location.assign(`${targetRoot}${path || '/'}${window.location.search}${window.location.hash}`);
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') { close(); this.querySelector('summary').focus(); }
        }, { signal });
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) close(); }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
